/* eslint-disable no-console */
import axios from "axios";
import { AppConfig } from "../config/app-config";
import { getToken } from "../auth-helper";

export const LoginApi = {
  login: (params: any) => {
    const apiBase = AppConfig.get("apiBase");
    // console.log(`BaseApi apiBase: ${apiBase}`);
    const token = getToken();
    // console.log(`BaseApi token: ${token}`);
    const url = `${apiBase}/login/`;
    // console.log(`BaseApi url: ${url}`);
    return axios.post(url, params, {
      headers: {
        Authorization: `JWT ${token}`,
        "Content-Type": "application/json",
      },
    });
  },
};
